import { useTranslation } from 'react-i18next';

import {
  Button,
  ButtonsWrapper,
  Form,
  Loader,
  Modal,
  PLATFORM_THEME_COLORS,
  SelectInput,
  Typography,
} from '@thinknet-gmbh/platform-common-ui';
import { DatevNumberStatusesEnum } from '@thinknet-gmbh/platform-common';

import { useGetCompanyByDatevNumber } from 'src/hooks/companies/get-company-by-datev.hook';
import { useGetAllDatevNumbers } from 'src/hooks/datev-numbers/get-datev-numbers.hook';
import { useGetCurrentCompanyId } from 'src/hooks/companies/get-current-company-id.hook';

import { IChangeDatevProps } from './change-datev-number.interfaces';
import { AttemptWrapper, ModalContentWrapper } from './change-datev-number.styles';
import { useUpdateCompanyDatevNumber } from 'src/hooks/companies/update-company-datev.hook';

const ChangeDatevNumber = ({
  isOpened,
  onClose,
  isOpenedAttention,
  onFinish,
  datev,
}: IChangeDatevProps) => {
  const { t } = useTranslation(['settings', 'common']);

  const currentCompanyId = useGetCurrentCompanyId();
  const { collection } = useGetAllDatevNumbers(currentCompanyId, DatevNumberStatusesEnum.FREE);
  const { company, loading } = useGetCompanyByDatevNumber(datev._id);

  const updateCompanyDatevNumber = useUpdateCompanyDatevNumber();

  const onSubmitForm = (values: any) => {
    updateCompanyDatevNumber({
      variables: { companyId: company._id, datevNumberId: values.datevNumberId },
    });

    onFinish();
  };

  if (loading) {
    return <Loader />;
  }

  return (
    <Modal
      isOpened={isOpened}
      onClose={() => onClose()}
      title={t('settings:datev.changeNumberModal.title')}
      smallerPadding
    >
      <ModalContentWrapper>
        <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
          {t('settings:datev.changeNumberModal.subtitle', { name: company.name })}
        </Typography>

        {isOpenedAttention && (
          <AttemptWrapper>
            <Typography weight="bold" fontColor={PLATFORM_THEME_COLORS.tone.red}>
              {t('settings:datev.changeNumberModal.attentionTitle')}
            </Typography>
            <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
              {t('settings:datev.changeNumberModal.attentionSubtitle')}
            </Typography>
          </AttemptWrapper>
        )}

        <Form layout="vertical" onFinish={onSubmitForm}>
          <Form.Item
            name="datevNumberId"
            label={t('settings:datev.labels.clientNumber')}
            rules={[
              { required: true, message: t('settings:datev.validation.clientNumberRequired') },
            ]}
          >
            <SelectInput placeholder="№0000000">
              {collection.map((datev: any) => (
                <SelectInput.Option value={datev._id} key={datev._id}>
                  {datev.datevNumber}
                </SelectInput.Option>
              ))}
            </SelectInput>
          </Form.Item>
          <ButtonsWrapper>
            <Button htmlType="submit" type="primary">
              {t('common:buttons.save')}
            </Button>
            <Button onClick={() => onClose()}>{t('common:buttons.cancel')}</Button>
          </ButtonsWrapper>
        </Form>
      </ModalContentWrapper>
    </Modal>
  );
};

export default ChangeDatevNumber;
